// extracted by mini-css-extract-plugin
export var smallSpinner = "_rn-0";